export default __webpack_public_path__ + "static/media/close-circle-blue.154645c3.svg";